//_components/onboarding/registration/AccountRegisterStep4.tsx
import api from "@/lib/axiosInstance";
import { motion } from "framer-motion";
import Image from "next/image";
import { toast } from "sonner";

type Step4Props = {
  onBack: () => void;
  email: string | undefined;
};

export default function AccountRegisterStep4({ onBack, email }: Step4Props) {
  const resendVerificationMail = async () => {
    try {
      await api.post("/auth/resend-verify", {email});
      toast.success("Verification email sent! Check your inbox.");
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message || "Error sending email";
      toast.error(errorMsg);
    }
  };
  return (
    <div className="text-center">
      <motion.h1
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-3xl font-semibold text-gray-800"
      >
        Verify your email
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="mt-4 text-sm text-gray-600"
      >
        Almost there! We've sent a verification email to{" "}
        <span className="font-medium">{email}</span>
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="mt-8 flex justify-center"
      >
        <Image
          src={"/assets/icons/mail-validation.svg"}
          width={100}
          height={100}
          className="w-16 h-16"
          alt="email verification icon"
        />
      </motion.div>

      <motion.button
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        onClick={resendVerificationMail}
        className="mt-8 px-8 py-3 rounded-full bg-green-800 text-white font-medium hover:bg-green-700"
      >
        Resend Email
      </motion.button>
    </div>
  );
}
